var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36288_39310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3359 22V1.66406H1V22H21.3359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36288_39310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5267 9.94423L10.7499 19.721C8.44042 22.0305 4.69597 22.0305 2.38642 19.721C0.0769216 17.4115 0.0769216 13.667 2.38642 11.3575L11.5244 2.21957",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42773 10.8906L14.952 4.36635",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1008 7.7925L7.96289 16.9304C7.19304 17.7003 5.94485 17.7003 5.17504 16.9304C4.40519 16.1606 4.40519 14.9124 5.17504 14.1426L8.42749 10.8901",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9512 4.36962C16.4908 2.82996 18.9872 2.82996 20.5268 4.36962C22.0665 5.90927 22.0665 8.40562 20.5269 9.94531",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocClip);
export default __webpack_public_path__ + "static/media/docClip.dd4f8c666dfae7ab3e0348b3b2248b10.svg";
export { ForwardRef as ReactComponent };